<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Filtreler
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Arşiv durumu</label>
          <v-select
            :value="deletedFilter"
            :options="deletedOptions"
            class="w-100 custom-vue-select"
            :reduce="val => val.value"
            @input="(val) => $emit('update:deletedFilter', val)"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {
    deletedFilter: {
      type: [String, null],
      default: null,
    },
    deletedOptions: {
      type: Array,
      required: true,
    },
  },
}
</script>

